import * as React from 'react';
import { Col, Dropdown } from '@geberit/gdds';

interface FilterProps {
  id: string;
  items: Array<any>;
  value: string;
  setValue: Function;
}

function Filter({ id, items, value, setValue }: Readonly<FilterProps>) {
  const handleChange = ({ value: newValue }) => {
    setValue(newValue);
  };

  return (
    <Col size={[4, 8, 3]}>
      <Dropdown
        items={items}
        onChange={handleChange}
        id={id}
        name={id}
        values={{ [id]: value }}
        defaultValue=""
        outlined
      />
    </Col>
  );
}

export default Filter;
